import { render, staticRenderFns } from "./OrderSenderView.vue?vue&type=template&id=71afeb1b&"
import script from "./OrderSenderView.vue?vue&type=script&lang=js&"
export * from "./OrderSenderView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports